import { Checkbox, Flex, Text } from '@radix-ui/themes';
import PropTypes from 'prop-types';
import React from 'react';
import InputFieldWrapper from '~/components/InputFieldWrapper';

export const TECHNOLOGIES = [
  { label: '2G/3G', value: '2g_3g' },
  { label: '4G', value: '4g' },
  { label: 'SMS', value: 'sms' },
];

export default function TechnologiesInput({ items, onChange, errorText, size = '2' }) {
  const handleToggle = ({ technology, checked }) => {
    const current = structuredClone(items);
    const item = current[technology];
    item.checked = checked;
    item.indeterminate = false;
    onChange(current);
  };

  return (
    <InputFieldWrapper
      label='Technologies'
      helpText='Some of the selected SIMs already have technologies, they have been pre-selected.'
      errorText={errorText}
    >
      <Flex
        direction='column'
        gap='2'
      >
        {TECHNOLOGIES.map(({ label, value }) => {
          const item = items[value] || {};
          const checkedState = item.indeterminate ? 'indeterminate' : item.checked;
          return (
            <Flex
              gap='2'
              align='center'
              key={value}
            >
              <Checkbox
                size={size}
                variant='surface'
                checked={checkedState}
                onCheckedChange={checked => handleToggle({ technology: item.value, checked })}
              />
              <Text size={size}>{label}</Text>
            </Flex>
          );
        })}
      </Flex>
    </InputFieldWrapper>
  );
}

TechnologiesInput.propTypes = {
  items: PropTypes.objectOf({
    indeterminate: PropTypes.bool,
    checked: PropTypes.bool,
    label: PropTypes.string,
    value: PropTypes.string,
  }),
  errorText: PropTypes.string,
  size: PropTypes.oneOf(['1', '2', '3']),
  onChange: PropTypes.func,
};
